import { Table, Typography } from "antd";

import { useTranslation } from "react-i18next";

const { Title } = Typography;

// เปิดแท็บใหม่แบบไม่ให้หน้าใหม่แตะ window.opener (กัน tabnabbing) — ใช้กับหัวตารางที่ผูก event ที่ <th>
const openInNewTab = (href) => window.open(href, "_blank", "noopener,noreferrer");

const drilldownHeaderCell = (href, keyLabel, period, t) => () => ({
  className: "es-summary-key-header",
  role: "link", // เปิดแท็บใหม่ = ลิงก์ ไม่ใช่ปุ่ม
  tabIndex: 0,
  "aria-label": t("Drilldown.Open_Key_Header", { keyLabel, period: period.label }),
  "data-testid": `inbound-company-drilldown-${period.key}`,
  onClick: () => openInNewTab(href),
  onKeyDown: (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openInNewTab(href);
    }
  },
});

const warehouseHeader = (code, total) =>
  total == null ? (
    code
  ) : (
    <span className="es-summary-col-head">
      {code}
      <span className="es-summary-col-total">({total})</span>
    </span>
  );

const buildColumns = (keyLabel, warehouses, { keyHeaderHref, rowNameHref, columnTotals, period, t } = {}) => {
  const modeChildren = (mode) =>
    warehouses.map((code) => ({
      title: warehouseHeader(code, columnTotals?.[mode]?.[code]),
      dataIndex: [mode, code],
      key: `${mode}-${code}`,
      align: "center",
      render: (value) => value ?? "-",
    }));

  return [
    {
      title: keyHeaderHref ? <span className="es-summary-key-link">{keyLabel}</span> : keyLabel,
      dataIndex: "name",
      key: "name",
      width: 56,
      fixed: "left",
      ...(rowNameHref
        ? {
            render: (value) => {
              const href = rowNameHref(value);
              if (!href) return value;
              return (
                <a
                  className="es-summary-row-link"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("Drilldown.Open_Row", { name: value, period: period.label })}
                >
                  {value}
                </a>
              );
            },
          }
        : {}),
      ...(keyHeaderHref ? { onHeaderCell: drilldownHeaderCell(keyHeaderHref, keyLabel, period, t) } : {}),
    },
    { title: "SEA", children: modeChildren("sea") },
    { title: "LAND", children: modeChildren("land") },
  ];
};

const SummaryPanel = ({
  title,
  keyLabel,
  warehouses = [],
  periods = [],
  keyHeaderHref,
  rowNameHref,
  scrollY,
  showColumnTotals = false,
}) => {
  // title / keyLabel / period.label มาจาก BE — ยังเป็นอังกฤษตาม §7.8 (FE แปลเฉพาะ chrome ของตัวเอง)
  const { t } = useTranslation("dashboard");
  const scrollX = 56 + warehouses.length * 2 * 64;

  const columnsFor = (period) =>
    buildColumns(keyLabel, warehouses, {
      period,
      t,
      keyHeaderHref: keyHeaderHref?.(period.key),
      rowNameHref: rowNameHref && ((name) => rowNameHref(name, period.key)),
      columnTotals: showColumnTotals ? period.columnTotals : null,
    });

  return (
    <div className="es-summary-block">
      {title && (
        <Title level={5} className="es-section-title">
          {title}
        </Title>
      )}
      <div className="es-summary-grid">
        {periods.map((period) => (
          <div key={period.key} className="es-summary-col">
            <div className="es-period-bar">
              <span className="es-period-label">{period.label}</span>
              <span className="es-period-total">{period.total}</span>
            </div>
            <Table
              className="es-summary-table"
              columns={columnsFor(period)}
              dataSource={period.rows}
              pagination={false}
              size="small"
              bordered
              scroll={{ x: scrollX, y: scrollY }}
              locale={{ emptyText: t("Table.No_Data") }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryPanel;
